import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import { getCurrentPaymentMethodOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import { getCurrentFeatures, type PaymentSpec } from '@tectonics/prs/payment-spec';
import type { PrsSupport } from '@tectonics/prs/support';
import type { UserInputValues } from '@tectonics/prs/user-input-values';
import { onlyWhenSupport } from '@tectonics/prs/validation';

type BuildOptionalFieldsParams = {
  readonly incomingPayment: IncomingPayment;
  readonly userInputValues: UserInputValues;
  readonly spec: PaymentSpec;
  readonly prsSupport: PrsSupport;
};

export const buildOptionalFields = ({ incomingPayment, userInputValues, spec, prsSupport }: BuildOptionalFieldsParams) => {
  const currentFeatures = getCurrentFeatures(spec, userInputValues.selectedPaymentMethod);

  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  const optionalFields = incomingPayment.status === 'OP'
    ? (getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) ?? [])
    : [];

  return { onlyWhen, optionalFields };
};
